import RailyOfficerAddRequest, {
  RailyOfficerAddRequestBody,
} from "./raily-officer-add.request";

const createBody = (
  data: RailyOfficerAddRequest
): RailyOfficerAddRequestBody => {
  return {
    email: data.email,
    firstName: data.firstName,
    lastName: data.lastName,
    mobilePrimary: data.mobilePrimary,
    mobilePrimaryPrefix: data.mobilePrimaryPrefix,
    mobileSecondary: data.mobileSecondary,
    mobileSecondaryPrefix: data.mobileSecondaryPrefix,
    password: data.password,
    username: data.username,
  };
};

const railyOfficerAddRequestFactory = {
  createBody,
};

export default railyOfficerAddRequestFactory;
